"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCanteen = function SvgCanteen(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.981 6.037v7.872",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#4D4D4D",
    cx: 10,
    cy: 14,
    rx: 3,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 8.5h2v-7a1 1 0 1 0-2 0v7z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4D4D4D",
    y: 8,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 20 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 8.5h2v-7a1 1 0 1 0-2 0v7z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4D4D4D",
    y: 8,
    width: 5,
    height: 2,
    rx: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#4D4D4D",
    cx: 10,
    cy: 4.5,
    rx: 6,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.465 9v6m11.038-6v6m3.954-6v6M.5 9v6",
    stroke: "#4D4D4D"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgCanteen);
var _default = Memo;
exports["default"] = _default;